import DiamondSvg from '@/assets/general/Three Diamonds.svg';
import { styled } from '@/style';

export const DiamondHr = styled(DiamondSvg)`
  color: palette-primary;
  width: 50px;
  margin: md auto;
`;
